import { render, staticRenderFns } from "./fintech_type.vue?vue&type=template&id=6ffd3610&scoped=true&"
import script from "./fintech_type.vue?vue&type=script&lang=js&"
export * from "./fintech_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd3610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ffd3610')) {
      api.createRecord('6ffd3610', component.options)
    } else {
      api.reload('6ffd3610', component.options)
    }
    module.hot.accept("./fintech_type.vue?vue&type=template&id=6ffd3610&scoped=true&", function () {
      api.rerender('6ffd3610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/fintech_type.vue"
export default component.exports